/**
 * Created by kutenai on 6/21/17.
 */


// Make sure we get all items, i.e. the styles
import '@digi-key/properties-sidebar'

import '@digi-key/schemeit-sidebar'
import api from '@digi-key/properties-sidebar'

module.exports = api







// WEBPACK FOOTER //
// ./src/sidebar_bundle.js